import DataService from "../../../../Application/services/dataServices/typedDataService";

import { type AppDispatch, type AppThunk } from "features/Application/globaltypes/redux";
import KnownHttpHeaders from "features/Application/services/knownHttpHeaders";
import { formatFiltersV2api, mapToV2Filters } from "utils/queryUtils";
import { escapeTerm } from "utils/searchUtils";
import { v2FilterMap, type GetContentUsersParams } from "../../../../People/types";
import { fetchBegin, fetchFailure, fetchSuccess } from "../slices/UsersSlice";

export const fetchUsersAction =
  ({ entityId, skip, top, sortingColumn, sortingDirection, filter, term }: GetContentUsersParams): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(fetchBegin());
    try {
      const filters = formatFiltersV2api(mapToV2Filters(filter, v2FilterMap));
      const searchTerm = escapeTerm(term);
      const response = await DataService.scorm.getUsers(
        entityId,
        skip,
        top,
        sortingColumn,
        sortingDirection,
        filters,
        searchTerm,
      );
      const count = parseInt(response.headers[KnownHttpHeaders.RecordsCount]);
      const items = response.data;
      dispatch(fetchSuccess({ items, totalCount: count }));
    } catch (e) {
      dispatch(fetchFailure(e as Error));
    }
  };
